(() => {
  document.querySelectorAll('.rl-editorial').forEach((article) => {
    if (article.querySelector('#configurator')) {
      document.querySelectorAll('.relenser-site-header a, .relenser-mobile-cta a').forEach((link) => {
        if (link.hash === '#configurator' && link.origin === location.origin) link.setAttribute('href', '#configurator');
      });
    }
    const toc = article.querySelector('.rl-editorial-sidebar .rl-editorial-toc');
    if (!toc || toc.dataset.scrollspyReady) return;
    const sections = Array.from(toc.querySelectorAll('a[href^="#"]'))
      .map((link) => ({ link, heading: document.getElementById(decodeURIComponent(link.hash.slice(1))) }))
      .filter(({ heading }) => heading && article.contains(heading));
    if (!sections.length) return;
    toc.dataset.scrollspyReady = 'true';
    let current = null;
    let frame = 0;

    const update = () => {
      frame = 0;
      if (!toc.getClientRects().length) return;
      // Match the native anchor offset, with a little tolerance for rounding.
      const readingLine = (parseFloat(getComputedStyle(sections[0].heading).scrollMarginTop) || 110) + 10;
      let active = null;
      for (const section of sections) {
        if (section.heading.getBoundingClientRect().top > readingLine) break;
        active = section.link;
      }
      if (active === current) return;
      if (current) current.removeAttribute('aria-current');
      current = active;
      if (!current) return;
      current.setAttribute('aria-current', 'location');

      // Reveal the current entry only inside the sidebar, never scroll the page.
      const item = current.getBoundingClientRect();
      const panel = toc.getBoundingClientRect();
      if (item.top < panel.top + 12) toc.scrollTop += item.top - panel.top - 12;
      else if (item.bottom > panel.bottom - 12) toc.scrollTop += item.bottom - panel.bottom + 12;
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('hashchange', schedule);
    article.addEventListener('load', schedule, true);
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(article);
    if (document.fonts) document.fonts.ready.then(schedule);
    schedule();
  });
})();
